import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PassportView } from "@/components/PassportView";
import { Sparkles, Loader2, Eye, Clock, ShieldCheck } from "lucide-react";

export default function SharedCandidate() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/shared/candidate/${encodeURIComponent(token)}`)
      .then((r) => setData(r.data))
      .catch(() => setErr(true));
  }, [token]);

  if (err) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" data-testid="shared-invalid">
      <div className="h-12 w-12 rounded-2xl bg-slate-100 flex items-center justify-center mb-4"><Clock className="text-slate-400" size={22} /></div>
      <h1 className="font-head text-xl font-bold text-slate-800">Odkaz je neplatný alebo vypršal</h1>
      <p className="text-slate-500 mt-1 text-sm max-w-sm">Tento zdieľací odkaz už nie je aktívny. Požiadajte recruitera o nový odkaz.</p>
    </div>
  );
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-blue-700" /></div>;

  const expires = data.expires_at ? new Date(data.expires_at).toLocaleDateString("sk-SK") : null;

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="shared-candidate-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200">
        <div className="mx-auto max-w-md px-6 py-3 flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-blue-700 flex items-center justify-center"><Sparkles className="text-white" size={16} /></div>
          <span className="font-head font-bold tracking-tight">Profeeluj<span className="text-blue-700"> AI</span></span>
        </div>
      </header>
      <div className="mx-auto max-w-md px-6 py-6 space-y-4">
        <div className="rounded-2xl bg-blue-50 border border-blue-100 px-4 py-3 flex items-start gap-2 text-sm text-blue-700" data-testid="shared-readonly-banner">
          <Eye size={16} className="flex-shrink-0 mt-0.5" />
          <div>
            <span className="font-semibold">Zdieľaný náhľad — iba na čítanie.</span>
            <span className="block text-blue-700/70 text-xs mt-0.5">Profil vytvorila AI z CV. Interné poznámky a status nie sú súčasťou tohto náhľadu.{expires ? ` Platnosť do ${expires}.` : ""}</span>
          </div>
        </div>
        <PassportView p={data.candidate} />
        <div className="flex items-center gap-1.5 text-xs text-slate-400 justify-center pt-2">
          <ShieldCheck size={13} /> Chránené zdieľanie · Profeeluj AI
        </div>
      </div>
    </div>
  );
}
